'use strict';

module.exports = function(userA, userB) {  // eslint-disable-line complexity
    return (
        (userA.last_name || '').localeCompare(userB.last_name || '') ||
        (userA.first_name || '').localeCompare(userB.first_name || '') ||
        (userA.middle_name || '').localeCompare(userB.middle_name || '') ||
        (userA.username || '').localeCompare(userB.username || '')
    );
};
